<template>
    <div class="page-container">
      <TelegramHeader />
  
      <div class="whitepaper-content">
        <h1>Mudra Token – Whitepaper</h1>
  
        <section>
          <h2>Version</h2>
          <p><strong>Prepared by:</strong> Mudra Creative Technologies</p>
        </section>
  
        <section>
          <h2>1. Introduction</h2>
          <p>
            Mudra Token (MUDRA) is a decentralized, non-investment utility token designed to reward creative individuals
            such as writers, musicians, dancers, and actors for their content contributions on the Mudra platform.
            MUDRA does not promise any financial return or serve as a financial product.
          </p>
          <p>
            <strong>Disclaimer:</strong> Mudra Token is not a security. It is not intended for investment purposes and is not
            promoted for speculation or financial gain. The trading of MUDRA Tokens by users on third-party exchanges is
            outside the scope and control of the Mudra project.
          </p>
        </section>
  
        <section>
          <h2>2. Objective</h2>
          <p>
            To establish a transparent, fair, and accessible token-based reward system that recognizes creativity and content
            contributions in the entertainment industry.
          </p>
        </section>
  
        <section>
          <h2>3. Use Cases</h2>
          <ul>
            <li>Reward for creative contributions (writing, music, dance, acting)</li>
            <li>Reward viewers who engage with creative content</li>
            <li>Unlock platform features</li>
            <li>Transfer to user wallet (self-custody)</li>
          </ul>
        </section>
  
        <section>
          <h2>4. Token Utility</h2>
          <ul>
            <li>No investment, ROI, or guaranteed profit</li>
            <li>ETH withdrawal fee applies only as a technical service fee</li>
            <li>Free tokens earned via platform participation</li>
          </ul>
        </section>
  
        <section>
          <h2>5. Technology</h2>
          <ul>
            <li>Blockchain: Ethereum (ERC-20) or Polygon</li>
            <li>Token Standard: ERC-20</li>
            <li>Smart Contract: [Audited / Upcoming]</li>
            <li>Total Supply: 1,000,000,000,000 (1 Trillion)</li>
          </ul>
        </section>
  
        <section>
          <h2>6. Token Allocation</h2>
          <table>
            <thead>
              <tr>
                <th>Category</th>
                <th>Allocation</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Team</td><td>20%</td></tr>
              <tr><td>Community Rewards</td><td>20%</td></tr>
              <tr><td>Ecosystem Development</td><td>10%</td></tr>
              <tr><td>Public Availability</td><td>20%</td></tr>
              <tr><td>Reserve</td><td>30%</td></tr>
            </tbody>
          </table>
        </section>
  
        <section>
          <h2>7. Legal and Regulatory Status</h2>
          <ul>
            <li>Mudra Token is a reward-only utility token and is not categorized as a security or financial product.</li>
            <li>No SEBI, RBI, or FIU registration required</li>
            <li>No ICO, public fundraising, or profit-sharing</li>
            <li>Trading on exchanges is user-controlled</li>
          </ul>
        </section>
  
        <section>
          <h2>8. Tax and Compliance</h2>
          <ul>
            <li>ETH withdrawal fees may be declared as income by the Mudra team</li>
            <li>Users converting MUDRA to ETH/INR are responsible for tax reporting</li>
          </ul>
        </section>
  
        <section>
          <h2>9. Roadmap</h2>
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Writer reward model</td><td>✅ Complete</td></tr>
              <tr><td>Music/dance/acting uploads</td><td>🔄 In development</td></tr>
              <tr><td>Viewer token rewards</td><td>🔄 In development</td></tr>
              <tr><td>Withdrawal system</td><td>✅ Live</td></tr>
              <tr><td>Smart Contract audit</td><td>🛡️ In progress</td></tr>
              <tr><td>Exchange listing</td><td>🔜 Future (user-driven)</td></tr>
            </tbody>
          </table>
        </section>
  
        <section>
          <h2>10. Conclusion</h2>
          <p>
            Mudra Token is a secure, utility-driven blockchain token designed to empower creative talents worldwide
            without engaging in speculation or profit guarantees.
          </p>
        </section>
  
        <section>
          <h2>Contact</h2>
          <ul class="contact-list">
            <li>🌐 Website: <a href="https://mudra-token.web.app" target="_blank">mudra-token.web.app</a></li>
            <li>📧 Email: <a href="mailto:mudratoken25@gmail.com">mudratoken25@gmail.com</a></li>
            <li>🕊️ Twitter: <a href="https://twitter.com/Mudra_token" target="_blank">@Mudra_token</a></li>
            <li>💬 Telegram: <a href="https://t.me/+pcAStVBSRD44YzBl" target="_blank">@mudratoken_community</a></li>
            <li>📲 WhatsApp: <a href="https://whatsapp.com/channel/0029VbB4MMtEquiLJhto0z40" target="_blank">Join our WhatsApp Channel</a></li>
          </ul>
        </section>
      </div>
  
      <TelegramBottomNav />
    </div>
  </template>
  
  <script setup>
  import TelegramHeader from '@/components/TelegramHeader.vue';
  import TelegramBottomNav from '@/components/TelegramBottomNav.vue';
  </script>
  
  <style scoped>
  .page-container {
    background-color: #BB6622;
    color: white;
    min-height: 100vh;
    padding-bottom: 60px;
    overflow-y: auto;
  }
  .whitepaper-content {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
  }
  .whitepaper-content h1, .whitepaper-content h2 {
    text-align: center;
    color: #FFD700;
  }
  .whitepaper-content p, .whitepaper-content li {
    line-height: 1.6;
  }
  .whitepaper-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    color: white;
  }
  .whitepaper-content table, .whitepaper-content th, .whitepaper-content td {
    border: 1px solid #FFD700;
  }
  .whitepaper-content th, .whitepaper-content td {
    padding: 8px;
    text-align: left;
  }
  .contact-list {
    list-style-type: none;
    padding: 0;
  }
  .contact-list li {
    margin: 8px 0;
  }
  .contact-list a {
    color: #FFD700;
    text-decoration: underline;
  }
  </style>
  